/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import config from 'config'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import ButtonBase from '@material-ui/core/ButtonBase'
import NoResultContent from 'components/molecules/NoResultContent'

import { isEmptyObject } from 'lib/detectType'
import ReplaceUrlToLink from 'components/molecules/ReplaceUrlToLink'

const styles = theme => ({
  appDetailViewArea: {
    margin: '1em auto',
    maxWidth: 800,
    paddingLeft: '2em',
    paddingRight: '2em',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '.5em',
      paddingRight: '.5em'
    }
  },
  detailSelectImgArea: {
    padding: '1em',
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgba(0,0,0,0.07)',
    [theme.breakpoints.down('sm')]: {
      padding: '.5em'
    }
  },
  detailSelectImg: {
    backgroundColor: '#eee',
    width: '100%',
    paddingTop: '56.25%'
  },
  detailImgArea: {
    padding: '0.3em'
  },
  detailImg: {
    width: '100%',
    backgroundColor: '#eee',
    paddingTop: '56.25%',
    boxShadow: '0 1px 2px rgba(0,0,0,0.07)'
  },
  appDetailList: {},
  appDetailListItem: {
    paddingRight: 0,
    paddingLeft: 0
  },
  appDetailTitle: {
    fontSize: '1.3em'
  },
  appContent: {
    '&&': {
      paddingLeft: '2em',
      paddingRight: '2em'
    },
    [theme.breakpoints.down('sm')]: {
      '&&': {
        paddingLeft: '.5em',
        paddingRight: '.5em'
      }
    }
  },
  thumbnailImgArea: {
    paddingLeft: '2em',
    paddingTop: '2em',
    backgroundColor: '#eee'
  },
  thumbnailImg: {},
  contentImgBtn: {
    display: 'block',
    width: '100%'
  }
})

const AppDetailView = props => {
  const { classes, ...others } = props
  const {
    appListLoading = true,
    appData: {
      categories = [],
      thumbnail = {},
      screenshots = [],
      ...appData
    } = {},
    selectedDetailImg,
    onClickContentImg
  } = others
  if (appListLoading === true) {
    return null
  }
  return (
    <div className={classes.appDetailViewArea}>
      {isEmptyObject(appData) && appListLoading === false ? (
        <Grid container spacing={2}>
          <NoResultContent {...others} />
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item container alignItems="center" spacing={2} xs={12}>
            <Grid item>
              <div
                className={classes.thumbnailImgArea}
                style={{
                  backgroundSize: '100% 100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundImage: `url(${thumbnail.url})`
                }}
              />
            </Grid>
            <Grid alignItems="flex-end" spacing={1} container item xs={10}>
              <Grid item>
                <Typography
                  variant="display1"
                  classes={{
                    root: classes.appDetailTitle
                  }}
                >
                  {appData.appName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.detailSelectImgArea}>
              <div
                className={classes.detailSelectImg}
                style={{
                  backgroundSize: 'auto 100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundImage: `url(${
                    selectedDetailImg ||
                    (screenshots[0] ? screenshots[0].url : '')
                  })`
                }}
              />
            </Paper>
          </Grid>
          <Grid container item xs={12} justify="flex-start">
            {screenshots.map((img, index) => {
              const { url } = img
              return (
                <Grid item xs={4} sm={2}>
                  <ButtonBase
                    onClick={e => onClickContentImg(url)}
                    focusRipple
                    key={index}
                    className={classes.contentImgBtn}
                  >
                    <div className={classes.detailImgArea}>
                      <div
                        className={classes.detailImg}
                        style={{
                          backgroundSize: 'auto 100%',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundImage: `url(${url})`
                        }}
                      />
                    </div>
                  </ButtonBase>
                </Grid>
              )
            })}
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Typography
              gutterBottom
              style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}
            >
              {appData.intro}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{
                whiteSpace: 'pre-line',
                wordBreak: 'break-word',
                minHeight: 350
              }}
            >
              <ReplaceUrlToLink LinkProps={{ target: '_blank' }}>
                {appData.description}
              </ReplaceUrlToLink>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={2}
            className={classes.appContent}
          >
            <Grid item xs={12}>
              <Typography color="textSecondary" variant="caption">
                홈페이지
              </Typography>
              <Typography
                style={{ wordBreak: 'break-all', color: '#288ce4' }}
                variant="body2"
              >
                <a
                  style={{ color: 'inherit', textDecoration: 'none' }}
                  href={appData.homepage}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {appData.homepage}
                </a>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="textSecondary" variant="caption">
                이메일
              </Typography>
              <Typography style={{ wordBreak: 'break-all' }} variant="body2">
                {appData.email || '미등록'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="textSecondary" variant="caption">
                카테고리
              </Typography>
              <Typography variant="body2">
                {categories
                  .map(
                    category =>
                      config.categories[category.toUpperCase()] || category
                  )
                  .join(' ')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(AppDetailView)
